import app from '@/main'
import { cloneDeep } from 'lodash'
export default {
  LOGOUT(state) {
    state.user = null
    state.hasToken = false
    if (window.location.href.indexOf(CONFIG.noc2024) !== -1) {
      localStorage.clear()
      location.href = CONFIG.nocLogin
      return
    }
    if (state.route.meta.needLogin) {
      app.$router.replace({ name: 'login' })
    }
  },
  HAS_TOKEN(state, boolean) {
    state.hasToken = boolean
  },
  SET_USER(state, data) {
    state.user = state.user || {}
    state.user = { ...state.user, ...data }
  },
  SET_SITE_MSG(state, data) {
    state.site_msg = state.site_msg || {}
    state.site_msg = { ...state.site_msg, ...data }
  },
  SET_EXAMINEE_INFO (state, examineeInfo) {
    state.examineeInfo = examineeInfo
  },
  SETSTATE (state, arr) {
    if (Array.isArray(arr)) {
      arr.forEach(item => {
        state[item.key] = item.value
      })
    } else {
      state[arr.key] = arr.value
    }
  },
  SET_PROVENCE_DATA(state, payload) {
    state.areaList = payload.data.map(item => {
      item.children = []
      return item
    })
  },
  SET_CITY_DATA(state, payload) {
    const id = Number(payload.id)
    const data = payload.data
    state.areaList.forEach(v1 => {
      if (v1.id === id && !v1.children.length) {
        v1.children = data.map(item => {
          item.children = []
          return item
        })
      } else {
        v1.children = v1.children || undefined
      }
    })
    state.areaList = cloneDeep(state.areaList)
  },
  SET_DISISTRICT_DATA(state, payload) {
    const id = Number(payload.id)
    const data = payload.data
    state.areaList.forEach(v1 => {
      v1.children.forEach(v2 => {
        if (v2.id === id) {
          v2.children = data
        }
      })
    })
    state.areaList = cloneDeep(state.areaList)
  }
}
